import { defineStore } from 'pinia'

export default defineStore({
  id: 'nodeTypeDataTable',
  persist: true,
  state: () => {
    return {
      columnState: []
    }
  },
  actions: {
    setColumnNodeTypeState: function (payload: any) {
      this.columnState = payload
    }
  },
  getters: {
    getColumnNodeTypeState: (state: any) => state.columnState
  }
})
